import get from "lodash.get";
import React from "react";
import PropTypes from "prop-types";
import { usePromiseResolver } from "@evertrue/promise-resolver";
import ActivityBreakdown from "./activity-breakdown";
import PoolActivityNumbers from "./pool-activity-numbers";
import ApiContext from "../contexts/api-context";
import { Flex } from "@evertrue/et-components";
import { round, formatInteractionStatsByType } from "../utils/utils";

const VolunteerStatsModalActivity = ({ poolId, userId, activityDateParameters, volunteerAnalyticsData, ...props }) => {
  const promises = React.useContext(ApiContext);
  const [{ total: interactionTotalByPool = 0, interactionStatsByType = {} } = {}] = usePromiseResolver(
    () =>
      userId &&
      promises
        .fetchActivityType({
          poolId,
          activityDateParameters,
          solicitorUserId: userId,
        })
        .then(formatInteractionStatsByType),
    []
  );
  return (
    <Flex>
      <div className="volunteer-stats-modal-activity--breakdown">
        <ActivityBreakdown
          interactionStatsByType={interactionStatsByType}
          interactionTotalByPool={interactionTotalByPool}
          showBar={true}
        />
      </div>
      <div className="volunteer-stats-modal-activity--numbers">
        <PoolActivityNumbers
          interactionTotalByPool={volunteerAnalyticsData.total_activities}
          activityCoverage={`${round(volunteerAnalyticsData.activity_coverage)}%`}
        />
      </div>
    </Flex>
  );
};

VolunteerStatsModalActivity.propTypes = {
  activityDateParameters: PropTypes.object,
  poolId: PropTypes.number,
  userId: PropTypes.number,
  volunteerAnalyticsData: PropTypes.object,
};

export default VolunteerStatsModalActivity;
